/* Bussali lens availability rules (Claude, Oct 20 2026)
   Restricts the Doctor-Grade Lens Builder (Infinite Options) to what the lab can make:
   design -> material -> light/sun -> coating -> Rx (sphere, cylinder, add).
   Sources: Essilor Varilux Lenses Availability (July 2026), Essilor Eyezen Availability (May 2024),
   Shore Lens Product Portfolio (2017). Flat-top / trifocal / Shore View sphere+cyl are capped
   estimates (no published chart). Data lives in RULES below; edit there. */
(function () {
  'use strict';

  // ---------- data ----------
  // light codes: CL clear, GS GEN S, XA XTRActive, VA Vantage, POL Essilor polarized, XP Xperio, TINT solid, GRAD gradient
  var ALL_TINT = ['TINT', 'GRAD'];
  function row(sph, add, cyl, light, extra) {
    var r = { sph: sph, add: add, cyl: cyl, light: light.concat(ALL_TINT) };
    if (extra) for (var k in extra) r[k] = extra[k];
    return r;
  }
  var NA = null;
  var EZ = {
    C: row([-10, 7.5], null, -6, ['CL', 'POL', 'XP', 'GS', 'XA'], { lightSph: { GS: [-10, 6], XA: [-10, 6] } }),
    T: row([-10, 6], null, -6, ['CL', 'GS', 'XA']),
    P: row([-10, 8], null, -6, ['CL', 'POL', 'XP', 'GS', 'XA'], { lightSph: { GS: [-10, 6] } }),
    '6': row([-12, 8], null, -6, ['CL', 'GS']),
    '7': row([-14, 9], null, -6, ['CL', 'POL', 'XP', 'GS', 'XA']),
    '4': row([-20, 13], null, -6, ['CL', 'GS'], { premiumAR: true })
  };
  var RULES = {
    SV: EZ,
    EZ: EZ,
    IM: {
      C: row([-10, 6], [0.75, 3.5], -6, ['CL', 'GS']),
      T: row([-10, 6], [0.75, 3.5], -6, ['CL', 'GS']),
      P: row([-10, 6], [0.75, 3.5], -6, ['CL', 'GS']),
      '6': NA,
      '7': row([-14, 9], [0.75, 3.5], -6, ['CL', 'GS']),
      '4': row([-20, 13], [0.75, 3.5], -6, ['CL', 'GS'], { premiumAR: true })
    },
    SF: {
      C: row([-10, 6], [0.75, 4], -6, ['CL', 'POL', 'XP', 'GS', 'XA']),
      T: row([-10, 7.5], [0.75, 4], -6, ['CL', 'GS', 'XA']),
      P: row([-10, 8], [0.75, 4], -6, ['CL', 'POL', 'XP', 'GS', 'XA']),
      '6': row([-12, 8], [0.75, 4], -6, ['CL', 'GS']),
      '7': row([-14, 9], [0.75, 4], -6, ['CL', 'POL', 'XP', 'GS', 'XA']),
      '4': row([-20, 13], [0.75, 4], -6, ['CL', 'GS'], { premiumAR: true })
    },
    CM: {
      C: row([-10, 6], [0.75, 3.5], -6, ['CL', 'POL', 'XP', 'GS', 'XA']),
      T: row([-10, 6], [0.75, 3.5], -6, ['CL', 'GS', 'XA']),
      P: row([-10, 6], [0.75, 3.5], -6, ['CL', 'POL', 'XP', 'GS', 'XA']),
      '6': row([-12, 8], [0.75, 3.5], -6, ['CL', 'GS']),
      '7': row([-14, 9], [0.75, 3.5], -6, ['CL', 'POL', 'XP', 'GS', 'XA'], { lightAdd: { XA: [0.75, 3] } }),
      '4': NA
    },
    XR: {
      C: row([-10, 6], [0.75, 4], -6, ['CL', 'POL', 'XP', 'GS', 'XA']),
      T: row([-10, 6], [0.75, 4], -6, ['CL', 'GS']),
      P: row([-10, 6], [0.75, 4], -6, ['CL', 'POL', 'XP', 'GS', 'XA']),
      '6': NA,
      '7': row([-12, 9], [0.75, 4], -6, ['CL', 'GS', 'XA']),
      '4': row([-14, 13], [0.75, 4], -6, ['CL', 'GS'], { premiumAR: true })
    },
    SH: { // Shore View — sphere/cyl capped (no published limits)
      C: row([-10, 6], [0.75, 3.5], -4, ['CL', 'GS']),
      T: row([-10, 6], [1, 3.5], -4, ['CL']),
      P: row([-10, 6], [0.75, 3.5], -4, ['CL', 'GS'], { lightAdd: { GS: [1, 3] } }),
      '6': row([-10, 6], [0.75, 3.5], -4, ['CL']),
      '7': row([-10, 6], [0.75, 3.5], -4, ['CL']),
      '4': NA
    },
    FT: { // Flat Top 28 — CR-39 / poly / Trivex only; sphere/cyl capped
      C: row([-10, 6], [0.75, 4], -4, ['CL', 'GS', 'POL']),
      T: row([-10, 6], [1, 3], -4, ['CL']),
      P: row([-10, 6], [0.75, 3], -4, ['CL', 'POL']),
      '6': NA, '7': NA, '4': NA
    },
    TF: { // Trifocal 7x28 — CR-39 only
      C: row([-7, 7], [1.5, 3], -4, ['CL']),
      T: NA, P: NA, '6': NA, '7': NA, '4': NA
    }
  };
  var MAT_NAME = { C: 'Plastic CR-39', P: 'Polycarbonate', T: 'Trivex', '6': '1.60', '7': '1.67', '4': '1.74' };
  var DESIGN_NAME = { SV: 'Single Vision', EZ: 'EyeZen', IM: 'Varilux Immersia', SF: 'Varilux Shift', CM: 'Varilux Comfort Max', XR: 'Varilux XR Design', SH: 'Shore View', FT: 'Bifocal FT28', TF: 'Trifocal 7x28' };
  var LIGHT_NAME = { CL: 'Clear', GS: 'Transitions GEN S', XA: 'Transitions XTRActive', VA: 'Transitions Vantage', POL: 'Polarized', XP: 'Xperio polarized', TINT: 'Solid tint', GRAD: 'Gradient tint' };

  function designKey(v) {
    if (!v) return null;
    if (/Frame only/i.test(v)) return 'FRAME';
    if (/Single Vision/i.test(v)) return 'SV';
    if (/EyeZen/i.test(v)) return 'EZ';
    if (/Immersia/i.test(v)) return 'IM';
    if (/Bifocal/i.test(v)) return 'FT';
    if (/Trifocal/i.test(v)) return 'TF';
    if (/Shore View/i.test(v)) return 'SH';
    if (/Shift/i.test(v)) return 'SF';
    if (/Comfort Max/i.test(v)) return 'CM';
    if (/XR/i.test(v)) return 'XR';
    return null;
  }
  function matKey(v) {
    if (!v) return null;
    if (/CR-?39/i.test(v)) return 'C';
    if (/Polycarbonate/i.test(v)) return 'P';
    if (/Trivex/i.test(v)) return 'T';
    if (/1\.60/.test(v)) return '6';
    if (/1\.67/.test(v)) return '7';
    if (/1\.74/.test(v)) return '4';
    return null;
  }
  function lightKey(v) {
    if (!v) return null;
    if (/Clear/i.test(v)) return 'CL';
    if (/GEN S/i.test(v)) return 'GS';
    if (/XTRActive/i.test(v)) return 'XA';
    if (/Vantage/i.test(v)) return 'VA';
    if (/Xperio/i.test(v)) return 'XP';
    if (/Polarized/i.test(v)) return 'POL';
    if (/Gradient/i.test(v)) return 'GRAD';
    if (/tint/i.test(v)) return 'TINT';
    return null;
  }
  function num(t) {
    t = String(t || '').trim();
    if (!t || /^none|sphere only/i.test(t)) return 0;
    if (/^(pl|plano)/i.test(t)) return 0;
    var n = parseFloat(t.replace(/[^\d.+-]/g, ''));
    return isNaN(n) ? null : n;
  }

  // ---------- DOM helpers ----------
  function box() { return document.getElementById('infiniteoptions-container'); }
  function visible(el) { return !!(el && el.offsetParent !== null); }
  function fieldFor(el) { var c = box(); while (el && el.parentElement !== c) el = el.parentElement; return el; }
  function checkedVal(name) {
    var c = box(); if (!c) return null;
    var ins = c.querySelectorAll('input[type=radio][name="properties[' + name + ']"]');
    for (var i = 0; i < ins.length; i++) if (ins[i].checked && visible(fieldFor(ins[i]))) return ins[i].value;
    return null;
  }
  function radios(name) {
    var c = box(); if (!c) return [];
    return Array.prototype.filter.call(c.querySelectorAll('input[type=radio][name="properties[' + name + ']"]'), function (i) { return visible(fieldFor(i)); });
  }
  function visibleSelects(re) {
    var c = box(); if (!c) return [];
    return Array.prototype.filter.call(c.querySelectorAll('select'), function (s) { return re.test(s.name) && visible(fieldFor(s)); });
  }
  function fire(el) { try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {} }

  function setRadioAllowed(input, ok, why) {
    var lab = input.closest('label');
    input.disabled = !ok;
    if (lab) {
      lab.classList.toggle('bl-off', !ok);
      if (!ok) lab.setAttribute('title', why || 'Not available with this lens'); else lab.removeAttribute('title');
      var note = lab.querySelector('.bl-note');
      if (!ok && !note) { note = document.createElement('span'); note.className = 'bl-note'; lab.appendChild(note); }
      if (note) { if (ok) note.remove(); else if (note.textContent !== (why || 'Not available')) note.textContent = why || 'Not available'; }
    }
  }
  function ensureChecked(name) {
    var rs = radios(name); if (!rs.length) return;
    var cur = rs.filter(function (r) { return r.checked; })[0];
    if (cur && !cur.disabled) return;
    var first = rs.filter(function (r) { return !r.disabled; })[0];
    if (first) { first.checked = true; fire(first); }
  }

  function limitSelect(sel, lo, hi, label) {
    var changed = false, any = false;
    Array.prototype.forEach.call(sel.options, function (o) {
      if (!o.value) return; // placeholder
      var n = num(o.text);
      var ok = n === null || lo === null || (n >= lo - 1e-6 && n <= hi + 1e-6);
      if (o.disabled !== !ok) o.disabled = !ok;
      o.hidden = !ok;
      if (ok) any = true;
    });
    var curOpt = sel.options[sel.selectedIndex];
    if (curOpt && curOpt.value && curOpt.disabled) {
      sel.selectedIndex = Array.prototype.findIndex.call(sel.options, function (o) { return !o.value; });
      if (sel.selectedIndex < 0) sel.selectedIndex = 0;
      changed = true; fire(sel);
    }
    return changed;
  }

  // ---------- apply ----------
  var msgEl;
  function showMsg(txt) {
    var c = box(); if (!c) return;
    if (!msgEl) { msgEl = document.createElement('div'); msgEl.className = 'bl-msg'; msgEl.setAttribute('role', 'status'); }
    if (msgEl.parentElement !== c.parentElement) c.parentElement.insertBefore(msgEl, c.nextSibling);
    if (msgEl.textContent !== (txt || '')) msgEl.textContent = txt || '';
    msgEl.style.display = txt ? 'block' : 'none';
  }

  var busy = false, lastReset = 0;
  function apply() {
    if (busy) return; busy = true;
    try {
      var c = box(); if (!c) return;
      var d = designKey(checkedVal('Lens Design'));
      var notes = [];
      if (!d || d === 'FRAME' || !RULES[d]) { showMsg(''); return; }
      var tbl = RULES[d];

      // materials
      radios('Lens Material').forEach(function (r) {
        var m = matKey(r.value); var ok = !m || !!tbl[m];
        setRadioAllowed(r, ok, 'Not made in ' + DESIGN_NAME[d]);
      });
      ensureChecked('Lens Material');
      var m = matKey(checkedVal('Lens Material'));
      var spec = m && tbl[m];
      if (!spec) { showMsg(''); return; }

      // light & sun
      radios('Light & Sun').concat(radios('Light ~ Sun')).forEach(function (r) {
        var l = lightKey(r.value); var ok = !l || spec.light.indexOf(l) >= 0;
        setRadioAllowed(r, ok, 'Not available in ' + MAT_NAME[m] + ' ' + DESIGN_NAME[d]);
      });
      ensureChecked('Light & Sun'); ensureChecked('Light ~ Sun');
      var l = lightKey(lightVal()) || 'CL';

      // coatings: 1.74 requires a Crizal coating
      var cnames = {};
      Array.prototype.forEach.call(c.querySelectorAll('input[type=radio]'), function (i) {
        if (/Hard coat only|Standard Anti-Reflective|Crizal/i.test(i.value) && visible(fieldFor(i))) cnames[i.name] = 1;
      });
      Object.keys(cnames).forEach(function (nm) {
        var plain = nm.replace(/^properties\[|\]$/g, '');
        radios(plain).forEach(function (r) {
          var basic = /Hard coat only|Standard Anti-Reflective/i.test(r.value);
          setRadioAllowed(r, !(spec.premiumAR && basic), '1.74 requires a Crizal coating');
        });
        ensureChecked(plain);
      });

      // Rx
      var sph = (spec.lightSph && spec.lightSph[l]) || spec.sph;
      var add = (spec.lightAdd && spec.lightAdd[l]) || spec.add;
      var reset = false;
      visibleSelects(/Sphere/i).forEach(function (s) { reset = limitSelect(s, sph[0], sph[1]) || reset; });
      visibleSelects(/Cylinder|Cyl\b/i).forEach(function (s) { reset = limitSelect(s, spec.cyl, 0) || reset; });
      if (add) visibleSelects(/Add/i).forEach(function (s) { reset = limitSelect(s, add[0], add[1]) || reset; });

      var txt = DESIGN_NAME[d] + ' in ' + MAT_NAME[m] + ': sphere ' + fmt(sph[0]) + ' to ' + fmt(sph[1]) +
        ', cylinder to ' + fmt(spec.cyl) + (add ? ', add ' + fmt(add[0]) + ' to ' + fmt(add[1]) : '') + '.';
      if (reset) lastReset = Date.now();
      if (Date.now() - lastReset < 15000) txt += ' A prescription value outside this range was cleared. Please re-select it, or choose a thinner material.';
      showMsg(txt);
    } finally { busy = false; }
  }
  function lightVal() { return checkedVal('Light & Sun') || checkedVal('Light ~ Sun'); }
  function fmt(n) { return (n > 0 ? '+' : n < 0 ? '−' : '') + Math.abs(n).toFixed(2); }

  // ---------- validation on add to cart ----------
  function problems() {
    var c = box(); if (!c) return [];
    var d = designKey(checkedVal('Lens Design'));
    if (!d || d === 'FRAME' || !RULES[d]) return [];
    var m = matKey(checkedVal('Lens Material'));
    var spec = m && RULES[d][m];
    var out = [];
    if (!spec) { out.push((MAT_NAME[m] || 'This material') + ' is not available for ' + DESIGN_NAME[d] + '.'); return out; }
    var l = lightKey(lightVal()) || 'CL';
    if (spec.light.indexOf(l) < 0) out.push(LIGHT_NAME[l] + ' is not available in ' + MAT_NAME[m] + ' ' + DESIGN_NAME[d] + '.');
    var sph = (spec.lightSph && spec.lightSph[l]) || spec.sph;
    var add = (spec.lightAdd && spec.lightAdd[l]) || spec.add;
    function chk(re, lo, hi, what) {
      visibleSelects(re).forEach(function (s) {
        var o = s.options[s.selectedIndex]; if (!o || !o.value) return;
        var n = num(o.text); if (n === null) return;
        if (n < lo - 1e-6 || n > hi + 1e-6) out.push(what + ' ' + o.text + ' is outside what the lab can make for this lens.');
      });
    }
    chk(/Sphere/i, sph[0], sph[1], 'Sphere');
    chk(/Cylinder|Cyl\b/i, spec.cyl, 0, 'Cylinder');
    if (add) chk(/Add/i, add[0], add[1], 'Add');
    return out;
  }
  function guard(e) {
    apply();
    var p = problems();
    if (p.length) { e.preventDefault(); e.stopImmediatePropagation(); showMsg(p.join(' ')); if (msgEl && msgEl.scrollIntoView) msgEl.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  }
  window.addEventListener('submit', function (e) { var f = e.target; if (box() && f.contains && f.contains(box())) guard(e); }, true);
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[name=add],.product-form__cart-submit');
    if (b && box()) guard(e);
  }, true);

  // ---------- wiring ----------
  var css = document.createElement('style');
  css.textContent = '#infiniteoptions-container label.bl-off{opacity:.4;cursor:not-allowed;background:#f3f3f3!important;border-style:dashed!important}' +
    '#infiniteoptions-container label.bl-off *{cursor:not-allowed}' +
    '#infiniteoptions-container .bl-note{display:block;font-size:11px;font-weight:400;color:#777;margin-top:2px}' +
    '#infiniteoptions-container label:has(.bl-note){flex-direction:column}' +
    '.bl-msg{display:none;max-width:520px;margin:-8px 0 16px;padding:10px 12px;border-left:3px solid #111;background:#f6f6f6;font-size:13px;line-height:1.4;color:#222}';
  document.head.appendChild(css);

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 60); }
  document.addEventListener('change', function (e) { if (box() && box().contains(e.target)) schedule(); }, true);
  function watch() {
    var c = box();
    if (!c) return false;
    new MutationObserver(schedule).observe(c, { attributes: true, attributeFilter: ['style'], subtree: true, childList: true });
    schedule();
    return true;
  }
  if (!watch()) {
    var tries = 0, iv = setInterval(function () { if (watch() || ++tries > 60) clearInterval(iv); }, 250);
  }
  window.BussaliLensRules = { RULES: RULES, apply: apply, problems: problems };
})();
